import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { LocalStorageService } from './local-storage.service';
 
@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  language: string;
  constructor(private translates: TranslateService,
    private messageService: MessageService,
    private localStorageService: LocalStorageService,
    @Inject(DOCUMENT) private document: Document) { }

  checkLanguage() {
    this.language = this.localStorageService.GetItem('lang');

    this.setLanguage(this.language);
  }

  setLanguage(lang: string) {
    this.localStorageService.SetItem('lang', lang);
    this.language = lang;
    this.translates.setDefaultLang(this.language);
    this.translates.use(this.language);
  }

  changeLanguage(lang) {
    this.localStorageService.SetItem('lang', lang);
    this.translates.use(lang);

    //this.appService.setNewModuleId();
    //this.appService.setPageName();
    this.reload()
  }

  translateMessage(parent, child1, child2): string {
    const messageKey = `${parent}.${child1}.${child2}`;
    const messageKeyWithParent = `Messages.${messageKey}`;
    const message = this.translates.instant(messageKey);

    if (message && message !== messageKey) {
      return message;
    }

    const messageWithParent = this.translates.instant(messageKeyWithParent);

    if (messageWithParent && messageWithParent !== messageKeyWithParent) {
      return messageWithParent;
    }

    return null;
  }

  reload() {
    window.location.reload();
  }

  changeLangReport(lang: string) {
    this.document.documentElement.lang = lang;
  }
}
